import { GoogleAnalyticsProvider } from '../providers/google-analytics.provider'
import { analyticsService } from '../services/analytics.service'
import { isGoogleAnalyticsConfigured } from './is-google-analytics-configured.utils'

export interface GoogleAnalyticsRegistrationConfig {
  debug?: boolean
  appEnv?: string
  appName?: string
  providers?: {
    googleAnalytics?: { measurementId?: string }
  }
}

export type GtagFn = (...args: unknown[]) => void

/** Registers GoogleAnalyticsProvider when measurement ID and gtag are available. */
export function registerGoogleAnalyticsProvider(analyticsConfig: GoogleAnalyticsRegistrationConfig, gtagFn: GtagFn | undefined): void {
  const measurementId = analyticsConfig.providers?.googleAnalytics?.measurementId

  if (!isGoogleAnalyticsConfigured(measurementId)) {
    console.log('[Analytics] Google Analytics skipped — no measurement ID configured')
    return
  }

  if (!gtagFn) {
    console.warn('[Analytics] Google Analytics skipped — gtag not available')
    return
  }

  const googleProvider = new GoogleAnalyticsProvider(analyticsConfig.debug || false)
  googleProvider.setAppEnv(analyticsConfig.appEnv ?? 'development')
  if (analyticsConfig.appName) {
    googleProvider.setAppName(analyticsConfig.appName)
  }
  googleProvider.setGtag(gtagFn)
  analyticsService.registerProvider('googleAnalytics', googleProvider)
}
